<template>
    <v-app light>
        <router-view id="app"></router-view>
    </v-app>
</template>

<script>
    export default {
        name: 'app',
        components: {}
    }
</script>

<style lang="stylus">
    body, html {
        font-size 10px
    }
    #app {
        font-size 1.2rem
        font-family 'Roboto', sans-serif
    }
    .mce-branding.mce-widget.mce-label.mce-flow-layout-item.mce-last {
        display none
    }

    .redline {
        text-indent 3rem
    }
    @import '~vuetify/src/stylus/main'
    @import './assets/main.styl'
</style>
